import React from 'react';
import LabelValue from 'utils/components/LabelValue/LabelValue';
import DetailPanel from 'widgets/supportVisualisation/Content/DetailPanel';
import { RequestInfo } from './Requests';
import JsonPanel from 'utils/components/JsonPanel/JsonPanel';
import { toDateString } from 'widgets/supportVisualisation/SupportVisualisationHelpers';

export interface RequestPanelProps {
    request: RequestInfo;
    height: number;
    width: number;
}

export default function RequestPanel(props: RequestPanelProps) {
    const { request, height, width } = props;

    return (
        <DetailPanel className="RequestPanel" height={height} width={width}>
            <div className="info">
                <>
                    <LabelValue label="Key" value={request.key} />
                    <LabelValue label="Url" value={request.url} />
                    <LabelValue label="Type" value={request.verbInfo} />
                    <LabelValue
                        label="Sent Time"
                        value={toDateString(request.sentTime)}
                    />
                    <LabelValue
                        label="Correlation Id"
                        value={request.correlationId}
                    />
                    {request.response && (
                        <>
                            <LabelValue
                                label="Response Time"
                                value={toDateString(
                                    request.response.receivedTime
                                )}
                            />

                            <LabelValue
                                label="Status"
                                value={
                                    request.response.status?.toString() ?? ''
                                }
                            />
                        </>
                    )}
                    {request.headers && (
                        <LabelValue
                            label="Headers"
                            value={JSON.stringify(request.headers)}
                        />
                    )}
                </>
            </div>
            <div className="payloads">
                <>
                    {request.body &&
                        Object.keys(request.body as Record<string, unknown>)
                            .length > 0 && (
                            <div className="payload-container">
                                <h2>Request Body</h2>
                                <div className="payload">
                                    <JsonPanel data={request.body} />
                                </div>
                            </div>
                        )}

                    {request.response?.data && (
                        <div className="payload-container">
                            <h2>Response</h2>
                            <div className="payload">
                                <JsonPanel data={request.response?.data} />
                            </div>
                        </div>
                    )}
                </>
            </div>
        </DetailPanel>
    );
}
